import { Injectable } from '@angular/core';

export interface DefaultLocationPlace {
  formattedAddress: string;
  latitude: string;
  longitude: string;
  rawPlace: any;
}

@Injectable({
  providedIn: 'root',
})
export class DefaultLocationService {
  private villageCareDefaultLocation?: Promise<DefaultLocationPlace>;

  getVillageCareDefaultLocation(): Promise<DefaultLocationPlace> {
    if (!this.villageCareDefaultLocation) {
      this.villageCareDefaultLocation = this.resolveVillageCareDefaultLocation();
    }

    return this.villageCareDefaultLocation;
  }

  private resolveVillageCareDefaultLocation(): Promise<DefaultLocationPlace> {
    return new Promise((resolve, reject) => {
      const maps = (window as any)?.google?.maps?.places;
      if (!maps) {
        reject(new Error('Google Places API is not available.'));
        return;
      }

      const autocompleteService = new maps.AutocompleteService();
      autocompleteService.getPlacePredictions(
        {
          input: 'New York, NY',
          componentRestrictions: { country: 'us' },
        },
        (predictions: any[] | null, status: string) => {
          if (
            status !== maps.PlacesServiceStatus.OK ||
            !predictions ||
            predictions.length === 0
          ) {
            reject(new Error(`Unable to resolve default location: ${status}`));
            return;
          }

          const placeId = predictions[0].place_id;
          const placesService = new maps.PlacesService(document.createElement('div'));

          placesService.getDetails(
            {
              placeId,
              fields: ['formatted_address', 'geometry', 'address_components', 'name'],
            },
            (place: any, detailsStatus: string) => {
              if (
                detailsStatus !== maps.PlacesServiceStatus.OK ||
                !place?.geometry?.location
              ) {
                reject(new Error(`Unable to load default location details: ${detailsStatus}`));
                return;
              }

              resolve({
                formattedAddress: place.formatted_address || 'New York, NY',
                latitude: String(place.geometry.location.lat()),
                longitude: String(place.geometry.location.lng()),
                rawPlace: place,
              });
            }
          );
        }
      );
    });
  }
}
